<template>
<div class="main container-fluid">
    <div class="row">
        <div>
            <h4 class="admin_txt">Create State Admin</h4>
        </div>
        <div class="card_box">
            <!-- <div class="col-md-4" style="border-right:solid 1px #ccc; padding-left:10%">
                    <label class="label_admin" for="States">Enrolled States : </label>
                    <select v-model="selected" class="form-control" style="width:280px">
                        <option v-for="recipe in statesEnrolled" :value="recipe.stateCode+'_'+recipe.slug" :key="recipe.slug">
                            {{ recipe.slug }}
                        </option>
                    </select>
                    <br>
                    <button @click="moveToSetting()" class="btn btn-primary waves-effect waves-light mr-1">
                        Next
                    </button>
                </div> -->
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-6">
                        <div style="margin: 0 30px">
                            <form action="#" data-parsley-validate novalidate @submit.prevent>
                                <div style="margin-bottom: 20px" class="">
                                    <label class="label_admin" for="States">Enrolled States</label>
                                    <select class="selct_state" v-model="selected" @change="moveToSetting()">
                                        <!-- <option value="" disabled selected hidden>Choose Gender...</option> -->
                                        <option v-for="recipe in statesEnrolled" :value="recipe.stateCode+'_'+recipe.slug" :key="recipe.slug">
                                            {{ recipe.stateName }}
                                        </option>
                                    </select>
                                </div>
                                <div style="margin-bottom: 20px" class="">
                                    <label class="label_admin" for="">Email</label>
                                    <input class="input_admin" type="email" name="nick" parsley-trigger="change" required placeholder="Enter Email" :disabled="validated == 1" v-model="email">
                                </div>
                                <div style="margin-bottom: 20px" class="">
                                    <label class="label_admin" for="userName">Surname</label>
                                    <input class="input_admin" type="text" name="nick" parsley-trigger="change" required placeholder="Enter Surname" :disabled="validated == 1" v-model="surname">
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div style="margin: 0 30px">
                            <form action="#" data-parsley-validate novalidate @submit.prevent>
                                <div style="margin-bottom: 20px" class="">
                                    <label class="label_admin" for="FirstName">Name</label>
                                    <input type="text" name="name" parsley-trigger="change" :disabled="validated == 1" placeholder="Enter Name" class="input_admin" v-model="name">
                                </div>
                                <div style="margin-bottom: 20px" class="">
                                    <label class="label_admin" for="pass1">Othername</label>
                                    <input id="pass1" type="text" placeholder="Othername" required class="input_admin" :disabled="validated == 1" v-model="othername">
                                </div>
                                <div style="margin-bottom: 20px" class="">
                                    <label class="label_admin" for="passWord2">Phone Number <span style="color: red; margin-left: 10px; font-size: 10px"><i class="fas fa-asterisk"></i></span></label>
                                    <input data-parsley-equalto="#pass1" type="number" required placeholder="Phone Number" class="input_admin" :disabled="validated == 1" v-model="phone">
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div class="button_part">
                    <div class="">
                        <button class="cancel" type="submit" :disabled="validated == 1" @click="createInstAdmin()">
                            Cancel
                        </button>
                    </div>
                    <div class="">
                        <button class="save" type="submit" :disabled="validated == 1" @click="createInstAdmin()">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'
import {
    loadProgressBar
} from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'

///////// IMPORT COOKIE SERVICE
import httpRequest from "@/services/httpRequests.js";
import cookieOps from "@/services/cookieOps.js";

/////////////////////////

export default {
    name: 'createstateAdmin',

    data() {
        return {
            email: '',
            surname: '',
            name: '',
            othername: '',
            phone: '',
            validated: 1,
            splitstate: '',
            oktoshow: false,
            stateName: '',
            statesEnrolled: '',
            selected: ''
        }
    },

    beforeRouteEnter(to, from, next) {
        const fetch = httpRequest.get('state/enrolled').then(function (res) {
            next(vm => vm.setData(res))
        })
    },

    /// SCOPE METHODS
    methods: {
        //////// sweet allert serivice
        alertDisplay(w, x, y) {
            // $swal function calls SweetAlert into the application with the specified configuration.
            this.$swal(w, x, y);
        },
        // set data recieved from before entry
        setData(data) {
            let statesEnrolled = httpRequest.detokenizeData(data.data.dataToken)
            // statesEnrolled = statesEnrolled.data.filter((item) => {
            //     return (item.enrolledStatus == 1)
            //   })
            console.log(statesEnrolled);
            this.statesEnrolled = statesEnrolled.data
        },
        ///checks if 
        moveToSetting() {
            this.splitstate = this.selected.split('_')
            let thiss = this
            /// check if state already has admin
            const checkstate = httpRequest.post('admin/check/enrolled', {
                'stateCode': this.splitstate[0]
            }).then(function (res) {
                if (res.data.code == 's200') {
                    thiss.validated = 0
                } else {
                    thiss.validated = 1
                    thiss.alertDisplay('State Check', res.data.message, 'error');
                }
            })
        },

        /////// creates institution Admin
        createInstAdmin() {
            /// check if state already has admin
            const upData = {
                "firstName": this.surname,
                "lastName": this.name,
                "phone": this.phone,
                "email": this.email,
                "enrolledStateCode": this.splitstate[0]
            }
            let thiss = this
            const checkstate = httpRequest.post('auth/createinstitutionadmin', upData).then(function (res) {
                if (res.data.code == 's200') {
                    thiss.validated = 1
                    thiss.alertDisplay('State Admin Created', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('State Admin Not Created', res.data.message, 'error');
                }
            })
        }
    }

}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

.button_part {
    display: flex;
    justify-content: center;
    align-items: center;
}

@media (max-width: 1000px) {
    .button_part {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}

.main {
    padding: 0 80px;
}

@media (max-width: 1000px) {
    .main {
        padding: 0 30px;
    }

}

hr {
    border-bottom: solid 1px #ccc !important;
    margin: 0px;
}

template {
    position: relative;
    min-height: 100%;
}

body {
    padding-bottom: 60px;
    overflow-x: hidden;
}

.authentication-bg.enlarged {
    min-height: 100px;
}

body.authentication-bg {
    background-image: url(../../assets/bg-light-img.jpg);
    background-size: cover;
    background-position: center;
}

.mini {
    display: none;
}

.input_admin {
    padding: 20px;
    width: 100%;
    height: 55px;
    margin: 20px 0;
    background: #FFFFFF;
    border: 0.5px solid #D3D8DD;
    box-sizing: border-box;
    border-radius: 4px;
}

.cancel {
    padding: 10px;
    width: 200px;
    height: 60px;
    background: #EEEEEE;
    border-radius: 4px;
    margin-right: 20px;
    border: none;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #9A9A9A;

}

@media (max-width: 1000px) {
    .cancel {
        padding: 10px;
        width: 150px;
        height: 60px;
        background: #EEEEEE;
        border-radius: 4px;
        margin-right: 0px;
        border: none;
        font-family: Poppins;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #9A9A9A;
        margin-bottom: 20px;
    }
}

.save {
    padding: 10px;
    width: 200px;
    height: 60px;
    background: #555A6E;
    border-radius: 4px;
    border: none;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #FFFFFF;
}

@media (max-width: 1000px) {
    .save {
        padding: 10px;
        width: 150px;
        height: 60px;
        background: #555A6E;
        border-radius: 4px;
        border: none;
        font-family: Poppins;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #FFFFFF;
    }
}

.label_admin {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 115.5%;
    display: flex;
    align-items: center;

    color: #494949;
}

.selct_state {
    /* padding: 20px; */
    width: 100%;
    height: 55px;
    margin: 20px 0;
    background: #FFFFFF;
    border: 0.5px solid #D3D8DD;
    box-sizing: border-box;
    border-radius: 4px;
}

.admin_txt {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
}

.bi span {
    color: #999;
    font-size: 15px;
    margin-left: 5px
}

.cardmax {
    height: 500px;
    max-height: 500px;
    overflow: scroll
}

.setvalue {
    margin-left: 5px;
    border: solid 1px #ccc;
    color: #999;
    border-radius: 2px;
    padding-left: 4px;
}

.card_box {
    width: 100%;
    height: auto;
    margin: 40px 0;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 5% 10%;
}

@media (max-width: 1000px) {
    .card_box {
        width: 100%;
        height: auto;
        margin: 40px 0;
        background: #FFFFFF;
        border-radius: 10px;
        padding: 5% 10%;
    }
}
</style>
